import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid } from 'semantic-ui-react';
import { isNil } from 'lodash';

import BookingCalendar from '../components/booking/BookingCalendar';
import {
  fetchBookingEquipmentsByProject,
  fetchBookingRoomsByProject
} from '../data/booking/bookingActions';
import { setActiveProjectSection, SINGLE_PROJECT_BOOKING_SECTION } from '../data/projectActions';

class Booking extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasProject: false
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (isNil(nextProps.project)) {
      return null;
    }

    if (!prevState.hasProject && !isNil(nextProps.project)) {
      nextProps.dispatch(fetchBookingEquipmentsByProject(nextProps.project.id, () => {}));
      nextProps.dispatch(fetchBookingRoomsByProject(nextProps.project.id, () => {}));
    }

    return {
      hasProject: !isNil(nextProps.project)
    };
  }

  componentDidMount() {
    this.props.dispatch(setActiveProjectSection(SINGLE_PROJECT_BOOKING_SECTION));
  }

  render() {
    if (!this.props.project) return false; // fix error when refresh nav
    return (
      <Grid className="screen_booking">
        <Grid.Row className="five column booking-featured-top">
          <Grid.Column className="left floated">
            <h1 className="page-title">
              Booking <small>({this.props.project.name})</small>
            </h1>
          </Grid.Column>

          {/* <Grid.Column className={'right floated'}> */}
          {/* <Button */}
          {/* onClick={(event) => this.saveBookingsSelection()} */}
          {/* className={'green right floated save-bookings'}> */}
          {/* OK */}
          {/* </Button> */}
          {/* </Grid.Column> */}
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <BookingCalendar />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default connect(state => ({
  project: state.projects.single.active
}))(Booking);



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/containers/Booking.js